import React, { PropsWithChildren, createContext, useState } from 'react';

import { AdminPropertyContentResponse, PropertyResponse } from '~/services/AccommodationService';

interface PropertyDetailsState {
  propertyDetails?: PropertyResponse;
  propertyContent?: AdminPropertyContentResponse;
  setPropertyDetails: (propertyDetails: PropertyResponse) => void;
  setPropertyContent?: (propertyContent: AdminPropertyContentResponse) => void;
}

export const AccommodationPropertyDetailsContext = createContext<PropertyDetailsState>({} as PropertyDetailsState);

interface Props {
  content?: AdminPropertyContentResponse;
  details: PropertyResponse;
}

export function AccommodationPropertyDetailsContextProvider({ content, details, children }: PropsWithChildren<Props>) {
  const [propertyDetails, setPropertyDetails] = useState<PropertyResponse>(details);
  const [propertyContent, setPropertyContent] = useState<AdminPropertyContentResponse | undefined>(content);

  return (
    <AccommodationPropertyDetailsContext.Provider
      value={{
        propertyDetails,
        propertyContent,
        setPropertyDetails,
        setPropertyContent,
      }}
    >
      {children}
    </AccommodationPropertyDetailsContext.Provider>
  );
}

export default AccommodationPropertyDetailsContextProvider;
